export default __webpack_public_path__ + "f47a2bf22016b119e0851a057688c671.svg";